<template>
  <div class="bg">
    <div class="bigTitle">
      Specialist Solution
    </div>
    <div class="SolutionsBox">
      <div class="introduce">
        <div class="introduceBG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/solutionsBG.png" alt=""></div>
        <div class="introduceBox">
          <div style="position: relative;">
            <div class="introduceIMG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/Specialist Solutions/Specialist_RespondentRecruiting.png" alt=""></div>
            <div class="summary">
              <div>
                <div class="title">Respondent Recruitment</div>
                <div class="value">
                  We provide quality recruitment services for thousands of research studies, both qualitative and quantitative in nature.
                  </br>
                  <br>
                  Our success in recruitment is based on dedicated work, networking, and the application of innovative communication platforms and technology.
                  </br>
                  <br>
                  With over 15 years of experience in this field, we have continuously expanded and refreshed our panels, allowing us to support our clients by providing quality respondents for their studies.
                </div>
                <div class="button">
                  <el-button type="primary" @click="toPath('/contact?source=respondent')">REQUEST A BID</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SolutionsBox">
      <div class="introduce">
        <div class="introduceBG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/solutionsBG.png" alt=""></div>
        <div class="introduceBox">
          <div style="position: relative;">
            <div class="introduceIMG"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/Specialist Solutions/Specialist_BespokeResearchCommunity.png" alt=""></div>
            <div class="summary">
              <div>
                <div class="title"> Bespoke Research Community</div>
                <div class="value">
                  We design, recruit, and manage custom-made research communities for our clients. Through community studies, we bring a group of enthusiastic users (or potential users) together to provide prompt and high-quality input for product development and product experience improvement.

                </div>
                <div class="button">
                  <el-button type="primary" @click="toPath('/contact?source=researchcommunity')">REQUEST A BID</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path
      });
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "specialist",
          source: "",
          information: ""
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "specialist",
          source: this.$route.query.source,
          information: ""
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Nunito";
  color: #fff;
}
.bg {
  background-image: url(https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/Solutions_Background.png);
  background-size: cover;
}
.bigTitle {
  font-size: 60px;
  font-weight: 700;
  text-align: center;
  padding-top: 120px;
  padding-bottom: 50px;
}
.SolutionsBox {
  .introduce {
    position: relative;
    height: 750px;
    margin: 0 120px;
    .introduceBG {
      position: absolute;
      right: 6%;
      img {
        width: 100%;
      }
    }
    .introduceBox {
      position: absolute;
      left: 6%;

      // width: 100%;
      .introduceIMG {
        img {
          width: 100%;
        }
      }
      .summary {
        position: absolute;
        top: 0;
        padding: 0px 120px;
        height: 100%;
        display: flex;
        align-items: center;
        .title {
          font-size: 40px;
          font-weight: 700;
          // margin-top: 70px;
          margin-bottom: 50px;
        }
        .value {
          width: 70%;
          font-size: 20px;
        }
        .button {
          margin-top: 15px;
          button {
            background-color: #90bef9;
            border: none;
          }
        }
      }
    }
  }
}

// @media screen and (max-width: 576px) {
//   .bigTitle {
//     font-size: 80px;
//   }
//   .box {
//     flex-wrap: wrap;
//     .value {
//       width: 100%;
//       padding: 30px;
//       margin-bottom: 20px;
//       padding-bottom: 150px;
//       .title {
//         font-size: 75px;
//       }
//       .img {
//         width: 500px;
//         img {
//           width: 1000px;
//         }
//       }
//       .text {
//         font-size: 70px;
//       }
//       .more {
//         font-size: 70px;
//       }
//     }
//   }
// }
</style>